/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Per-scenario status for a housing application inside a vacancy scenario. This is
 * distinct from the overall Compliance.Module.Housing.DbModels.HousingApplicationStatus: one applicant
 * can hold a per-scenario status (e.g. Compliance.Module.Housing.Enums.HousingIntakeScenarioProcessedApplicationStatus.Interviewing) while their overall status is
 * still Compliance.Module.Housing.DbModels.HousingApplicationStatus.LockedInterviewing.
 */
export enum HousingIntakeScenarioProcessedApplicationStatus {
    INTAKE = 'Intake',
    INTERVIEWING = 'Interviewing',
    REJECTED = 'Rejected',
    NO_OFFER = 'NoOffer',
    ACCEPTED = 'Accepted',
    CANCELLED = 'Cancelled',
    OFFER_IN_PROGRESS = 'OfferInProgress',
    THIRD_STRIKE = 'ThirdStrike',
    INELIGIBLE = 'Ineligible',
    OFFER_REJECTED = 'OfferRejected',
    NO_OFFER_CANCELLED = 'NoOfferCancelled',
}
